<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      title="现场问题上传"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <van-form @submit="onSubmit">
      <div style="padding:20px">
        <div class="infoTit">上传问题</div>
        <div class="topDiv">
          <van-cell-group>
            <van-field label="问题类型" required readonly v-model="problem.problemTypeName" input-align="right"
                       placeholder="点击选择问题类型"
                       :rules="[{ required: true, message: '请选择问题类型'}]" @click="loadProblemType"/>
          </van-cell-group>
          <van-cell-group>
            <van-field label="问题子类" type="textarea" required readonly v-model="problem.problemSubclass"
                       input-align="right" placeholder="点击选择问题子类"
                       :rules="[{ required: true, message: '请选择问题子类'}]" @click="loadProblemSubclass"/>
          </van-cell-group>
          <van-cell-group>
            <van-field label="问题等级" required readonly v-model="problem.problemLevelName" input-align="right"
                       placeholder="点击选择问题等级"
                       :rules="[{ required: true, message: '请选择问题等级'}]" @click="loadProblemLevel"/>
          </van-cell-group>
          <van-cell-group>
            <van-field label="具体问题"  readonly v-model="problem.specificProblemName" input-align="right"
                       placeholder="请选择具体问题"
                       @click="loadProblemSubclass3"/>
          </van-cell-group>

          <van-cell-group>
            <van-field label="问题描述" type="textarea" maxlength="200" show-word-limit v-model="problem.problemDescription"
                       input-align="right" placeholder="点击输入问题描述"/>
          </van-cell-group>
          <van-cell-group>
            <van-field label="文件依据"  readonly v-model="problem.dictFileCodeName" input-align="right"
                       placeholder="请选择文件依据"
                       @click="loadProblemSubclass4"/>
          </van-cell-group>
          <van-cell-group>
            <div style="width: 95%;padding-left: 40px;font-size: 14px">
              {{problem.dictFileCodeName}}
            </div>
          </van-cell-group>
          <br>
          <van-cell-group>
            <van-field label="整改建议" type="textarea" maxlength="200" show-word-limit v-model="problem.suggestions"
                       input-align="right" placeholder="点击输入整改建议"/>
          </van-cell-group>
          <van-cell-group>
            <van-field name="uploader" label="问题照片" input-align="right">
              <template #input>
                <van-uploader v-model="problem.problemPhotoFiles"
                              @click-preview="clickPreview"
                              preview-size="60px"
                              :max-count="5"
                              :preview-full-image="false"
                              :before-read="beforeRead" />
              </template>
            </van-field>
          </van-cell-group>
<!--          <van-cell-group>-->
<!--            <van-field label="是否存在商机" input-align="right">-->
<!--              <template #input>-->
<!--                <van-switch v-model="problem.opportunity"/>-->
<!--              </template>-->
<!--            </van-field>-->
<!--          </van-cell-group>-->
        </div>
      </div>
      <div style="position: fixed;bottom: 0;width: 100%;z-index:100;">
        <van-button block native-type="submit" color="#1B75F6" plain @click="submitType.current = submitType.ALL.TEMP">离线暂存</van-button>
        <van-button style="margin-top: 1px" block color="#1B75F6" native-type="submit" @click="submitType.current = submitType.ALL.STRAIGHT" v-if="!isLoading">提交</van-button>
        <van-button style="margin-top: 1px" block color="#1B75F6" disabled loading  loading-type="spinner" v-if="isLoading">提交</van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
<!--      <van-field v-if="pickerType === 1" @input="matchProblemType" v-model="problemTypeMatcher" placeholder="搜索问题类型" clearable />
      <van-field v-else-if="pickerType===2" v-model="newSubClass" placeholder="请输入自定义问题子类" clearable/>-->
      <van-search
        v-model="searchValue"
        placeholder="请输入名称查询"
        @search="searchHY"
        shape="round"
        background="#F7F7F7"
      />
      <van-picker
        class="select-picker-color"
        ref="picker"
        show-toolbar
        :columns="pickerDict"
        @confirm="onConfirm"
        @cancel="showPicker = false; problemTypeMatcher = '';"
        @change="onPickerChange"
      />
    </van-popup>
  </div>
</template>

<script>

import $ from '@/fly'
import { Toast, ImagePreview,Dialog } from 'vant';
import { ProblemStore } from '@/libs/indexedDB'


const SUBMIT_TYPE_ALL = {
  STRAIGHT: 1,
  TEMP: 2,
}

export default {
  name: 'project-problem',
  data() {
    return {
      isLoading: false,
      childProblem:[],
      childProblem3:[],
      childProblem4:[],
      parentProblem:[],
      parentIndex:'',
      fileList: [],
      submitType: {
        ALL: SUBMIT_TYPE_ALL,
        current: SUBMIT_TYPE_ALL.STRAIGHT
      },
      clientHeight: window.screen.height,
      offlineTitle: {
        type: String,
        default: "网络已断开，请检查网络连接。",
      },
      onlineTitle: {
        type: String,
        default: "网络已连接",
      },
      desc: {
        type: String,
        default: "",
      },
      duration: {
        type: Number,
        default: 4.5,
      },
      problem: {
        projectId: '',
        companyId: '',
        problemType: '',
        problemTypeName: '',
        problemSubclass: '',
        problemDescription: '',
        problemLevel: '',
        problemLevelName: '',
        problemPhotoFiles: [],
        inspectionDate: '',
        suggestions: '',
        opportunity: false,
        specificProblem:'',
        dictFileCode:'',
        specificProblemName:'',
        dictFileCodeName: '',
        address: '',
        longitudeAndLatitude: '',
      },
      showPicker: false,
      pickerType: 0,
      pickerDict: [],
      problemTypeDict: [],
      problemLevelDict: [],
      problemTypeArr: [],
      problemLevelArr: [],
      problemSubclassArr: [],
      newSubClass: '',
      problemTypeMatcher: '',
      index3:'',
      index4:'',
      index5:'',
      searchValue: '',
    }
  },
  methods: {
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        console.log('当前浏览器不支持地理定位');
      }
    },
    // 获取定位成功，显示位置信息
    async showPosition(position) {
      console.log(
        'Latitude(纬度): ' + position.coords.latitude + // 纬度
        '<br>Longitude(经度): ' + position.coords.longitude); // 经度
      var gps = [position.coords.longitude, position.coords.latitude];
      // 参数说明：需要转换的坐标，需要转换的坐标类型，转换成功后的回调函数
      let lnglats = []
      await AMap.convertFrom(gps, 'gps', function (status, result) {
        if (result.info === 'ok') {
          lnglats = result.locations; // 转换后的高德坐标 Array.<LngLat>
          console.log(lnglats)
        }
      });

      let address = ''
      let longitudeAndLatitude = ''
      setTimeout(() => {
        // 这里是延迟执行的代码
        AMap.plugin('AMap.Geocoder', () => {
          var geocoder = new AMap.Geocoder({
            city: '200000' // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          })
          console.log("11111",lnglats)
          var lnglat = [lnglats[0].lng, lnglats[0].lat]
          longitudeAndLatitude = lnglats[0].lng+','+lnglats[0].lat
          geocoder.getAddress(lnglat, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              // result为对应的地理位置详细信息
              address = result.regeocode.formattedAddress
            }
            this.problem.address = address
            this.problem.longitudeAndLatitude = longitudeAndLatitude
          })
        })
      }, 4000);

    },
    // 获取定位失败，显示错误信息
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.log('用户拒绝地理定位请求');
          break;
      }
    },
    searchHY(){
      console.log('搜索',this.searchValue)
      console.log('type',this.pickerType)
      if(this.pickerType===1){
        this.loadProblemType()
      }else if(this.pickerType===2){
        this.loadProblemSubclass()
      }else if(this.pickerType===3){
        this.loadProblemLevel()
      }else if(this.pickerType===4){
        this.loadProblemSubclass3()
      }else if(this.pickerType===5){
        this.loadProblemSubclass4()
      }
    },
    loadProblemType() {
      this.showPicker = true;
      this.pickerType = 1;
      // this.pickerDict = this.problemTypeArr;
      let projectId = localStorage.getItem('projectId')
      $.get(
        'dictBusiness/getProblem/0/'+projectId+'?name='+this.searchValue
      ).then((res)=>{
        console.log(res)
        this.pickerDict = [];
        res.forEach(item=>this.pickerDict.push(item.name));
        this.parentProblem = res;
      })
    },
    loadProblemSubclass() {
      this.showPicker = true;
      this.pickerType = 2;
      if(undefined!==this.parentProblem[this.parentIndex]){
        $.get(
          'dictBusiness/getProblemChilds/'+this.parentProblem[this.parentIndex].id+'?name='+this.searchValue
        ).then((res)=>{
          this.pickerDict = []
          res.records.forEach(item=>this.pickerDict.push(item.name))
          this.childProblem = res.records;
        })
      }else{
        this.pickerDict = []
      }

    },
    loadProblemSubclass3() {
      this.showPicker = true;
      this.pickerType = 4;
      if(undefined!==this.childProblem[this.index3]){
        $.get(
          'dictBusiness/getProblemChilds/'+this.childProblem[this.index3].id+'?name='+this.searchValue
        ).then((res)=>{
          this.pickerDict = []
          res.records.forEach(item=>this.pickerDict.push(item.name))
          this.childProblem3 = res.records;
        })
      }else{
        this.pickerDict = []
      }

    },
    loadProblemSubclass4() {
      this.showPicker = true;
      this.pickerType = 5;
      if(undefined!==this.childProblem3[this.index4]){
        $.get(
          'dictBusiness/getProblemChilds/'+this.childProblem3[this.index4].id+'?name='+this.searchValue
        ).then((res)=>{
          this.pickerDict = []
          res.records.forEach(item=>this.pickerDict.push(item.name))
          this.childProblem4 = res.records;
        })
      }else{
        this.pickerDict = []
      }


    },
    loadProblemLevel() {
      this.pickerType = 3;
      $.get('dict/getDictByType/problemLevel?name='+this.searchValue).then(res=>{
       this.problemLevelDict = res
       this.problemLevelArr = []
       this.problemLevelDict.forEach(item => this.problemLevelArr.push(item.name))
       this.showPicker = true;
       this.pickerDict = this.problemLevelArr;
     })

    },
    onPickerChange(picker, value, index) {
      console.log(picker)
      console.log(value)
      console.log(index)
      if (this.pickerType === 2) {
        this.newSubClass = value;
      } else if (this.pickerType === 1)
        this.problemTypeMatcher = value
    },
    matchProblemType() {
      const matchedType = this.problemTypeArr.find(t => t === this.problemTypeMatcher)
      if (matchedType) this.$refs.picker.setColumnValue(0, matchedType)
    },
    onConfirm(value, index) {

      if (this.pickerType === 1) {
        if (value !== this.problem.problemTypeName) {
          this.problem.problemSubclass = '';
          this.problem.dictFileCodeName = ''
          this.problem.specificProblemName = ''
        }
        // 选择了问题类型
        this.problem.problemType = this.parentProblem[index].code;
        this.problem.problemTypeName = value;
        this.parentIndex = index;
      } else if (this.pickerType === 2) {
        if (value !== this.problem.problemSubclass) {
          this.problem.dictFileCodeName = ''
          this.problem.specificProblemName = ''
        }
        console.log(value,index)
        console.log('2',this.parentProblem[this.parentIndex])
        // 选择了问题子类
        this.problem.problemSubclass = value;
        this.index3 = index
        // this.problem.problemSubclass = value;
      } else if (this.pickerType === 3) {
        // 选择了问题等级
        var levelDict = this.problemLevelDict.filter(function (type) {
          return type.name === value
        })
        var level = levelDict[0];
        this.problem.problemLevel = level.code;
        this.problem.problemLevelName = level.name;
      }else if(this.pickerType === 4){
        console.log('具体',index)
        console.log('具体',value)
        if (value !== this.problem.specificProblemName) {
          this.problem.dictFileCodeName = ''
        }
        this.index4 = index
        this.problem.specificProblemName = value
        this.problem.dictFileCodeName = ''
      }else if(this.pickerType === 5){
        this.problem.dictFileCodeName = value
        this.index5 = index
      }
      this.showPicker = false;
      this.searchValue = ''
    },
    beforeRead(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        Toast('只允许上传jpg/png格式的图片！')
        return false;
      }
      return true
    },
    clickPreview({ content }) {
      ImagePreview({ images: [content], closeable: true })
    },
    async onSubmit() {
      console.log('经纬度：'+this.problem.longitudeAndLatitude+'    拍摄地址：'+this.problem.address)
      this.isLoading = true
      try{
        this.problem.projectId = localStorage.getItem('projectId');
        this.problem.companyId = localStorage.getItem('companyId');
        this.problem.inspectionDate = this.getCurrentDate();
        if (this.problem.opportunity) {
          this.problem.opportunity = 1;
        } else {
          this.problem.opportunity = 0;
        }
        if(this.childProblem3.length>0){
          console.log('index',this.index4)
          if(this.childProblem3[this.index4]!==undefined){
            this.problem.specificProblem = this.childProblem3[this.index4].code
          }

        }

        if(this.childProblem4.length>0){
          if(this.childProblem4[this.index5]!==undefined){
            this.problem.dictFileCode = this.childProblem4[this.index5].code
          }

        }



        if (this.submitType.current === SUBMIT_TYPE_ALL.STRAIGHT) {
          this.problem.problemPhotoFiles = this.problem.problemPhotoFiles.map(p => p.file)
          const aIds = this.problem.problemPhotoFiles.length? await $.multiUploadAddWaterMarking(this.problem.problemPhotoFiles,null,this.problem.address,this.problem.longitudeAndLatitude) : []
          $.post('problem', JSON.stringify([{ ...this.problem, problemPhotoFiles: null, problemPhotos: aIds.join(',') }]),
            { contentType: 'application/json' }
          ).then(res=> {
            let problemIds = localStorage.getItem('problemIds')
            if(problemIds===''){
              localStorage.setItem('problemIds',res)
            }else{
              localStorage.setItem('problemIds',problemIds+','+res)
            }
            Toast.success('上传成功！');
            this.$router.back();
          }).catch(err => {
            Toast.fail(err.message);
          })
        } else if (this.submitType.current === SUBMIT_TYPE_ALL.TEMP) {
          let problemPhotoFiles = this.problem.problemPhotoFiles
          if (problemPhotoFiles && problemPhotoFiles.length)
            problemPhotoFiles = problemPhotoFiles.map(p => ({ url: p.content, filename: p.file.name }))
          ProblemStore.add({ ...this.problem, problemPhotoFiles })
          Toast.success('暂存成功！');
          this.$router.back()
        }
      }catch (err){
        Toast.fail('保存失败！'+err);
        this.isLoading = false
      }
    },
    eventHandle(event) {
      const type = event.type === "offline" ? "error" : "success";
      if (type=="error"){
        let ads = prompt("您现在是离线状态，请输入拍摄地址",'')
        for (let i = 1; i < 3; i++) {
          if (ads==''){
            ads = prompt("您现在是离线状态，请输入拍摄地址",'')
          }else {
            return;
          }
        }
          this.problem.address = ads
          this.problem.longitudeAndLatitude = ''
      }
      setTimeout(() => {
        this.mask = event.type === "offline";
      }, 1500);
    },
    // 获取当前年月日
    getCurrentDate() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      const newmonth = date.month >= 10 ? date.month : '0' + date.month
      const day = date.date >= 10 ? date.date : '0' + date.date
      return date.year + '-' + newmonth + '-' + day
    }
  },
  async mounted() {
    window.addEventListener("offline", this.eventHandle);
    window.addEventListener("online", this.eventHandle);
    await this.getLocation();
    // this.problemTypeDict = JSON.parse(sessionStorage.getItem('problemTypeDict') || '[]')
    // if (!this.problemTypeDict.length)
    //   this.problemTypeDict = await $.get('dict/getDictByType/problemType')
    // this.problemTypeDict.forEach(item => this.problemTypeArr.push(item.name))
    this.problemLevelDict = JSON.parse(sessionStorage.getItem('problemLevelDict') || '[]')
    if (!this.problemLevelDict.length)
      this.problemLevelDict = await $.get('dict/getDictByType/problemLevel')
    this.problemLevelDict.forEach(item => this.problemLevelArr.push(item.name))

  },
  beforeDestroy() {
    window.removeEventListener("offline", this.eventHandle);
    window.removeEventListener("online", this.eventHandle);
  },
}
</script>

<style lang="less" scoped>
.topDiv {
  margin-top: 30px;
  padding: 20px;
  background-color: #FFFFFF;
}

.infoTit {
  color: #242E42;
  font-size: 30px;
  font-weight: bold;
}
/deep/.select-picker-color .van-ellipsis {
  color: #000000 !important;
}
</style>
